var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8556",
    "data-name": "Group 8556",
    transform: "translate(-504 -263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H20V20H0Z",
    transform: "translate(504 263)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M14.879,14.677a.827.827,0,0,1-.827.828H.827A.827.827,0,0,1,0,14.677v-8.7a.828.828,0,0,1,.319-.654L6.932.174a.826.826,0,0,1,1.015,0l6.613,5.15a.828.828,0,0,1,.319.654v8.7Z",
    transform: "translate(506.561 264.935)",
    fill: "#de1186",
    stroke: "rgba(255,255,255,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3683",
    "data-name": "Rectangle 3683",
    width: 1.5,
    height: 5.5,
    rx: 0.75,
    transform: "translate(513.25 272.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActiveIcon);
export default __webpack_public_path__ + "static/media/home-active-icon.90b0f42da674b9c2c7ffe06ce60d5cc6.svg";
export { ForwardRef as ReactComponent };